import { TIconColors } from '@/types/icons';

export const IconColors: Record<TIconColors, string> = {
	blue: 'var(--color-blue)',
	white: 'var(--color-white)',
	gray: 'var(--color-grey)',
};
